module.exports = __webpack_public_path__ + "static/img/recommend_bg.405f17d2.png";